module.exports = __webpack_public_path__ + "img/icon2.e721923a.png";